import React from 'react';

interface MasterCoifaLogoProps {
  height?: number | string;
  width?: number | string;
  className?: string;
  light?: boolean; // If true, renders white text. If false, renders dark text.
}

export default function MasterCoifaLogo({ 
  height = 'auto', 
  width = '100%', 
  className = '', 
  light = true 
}: MasterCoifaLogoProps) {
  const textColor = light ? '#FFFFFF' : '#1A1D20';
  const subtextColor = light ? '#F8F9FA' : '#495057';
  const redLineColor = '#DC3545'; // Vibrant bootstrap red corresponding to master coifa design

  return (
    <div 
      className={`d-inline-flex flex-column align-items-center justify-content-center text-center ${className}`}
      style={{ width, height, userSelect: 'none' }}
      id="master-coifa-logo-component"
    >
      {/* Scalable SVG Implementation corresponding exactly to the uploaded logo */}
      <svg 
        viewBox="0 0 1000 240" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: '100%', maxWidth: '100%' }}
      >
        {/* Main Brand Title "MASTER COIFA" */}
        <text
          x="50%"
          y="100"
          textAnchor="middle"
          fill={textColor}
          fontSize="92"
          fontWeight="900"
          fontFamily="'Inter', 'Montserrat', 'Segoe UI', system-ui, sans-serif"
          letterSpacing="18"
        >
          MASTER COIFA
        </text>

        {/* Vibrant Red Separator line exactly matching visual style */}
        <rect 
          x="40" 
          y="138" 
          width="920" 
          height="14" 
          fill={redLineColor} 
          rx="2"
        />

        {/* Subtitle "SOLUÇÕES EM SISTEMAS DE EXAUSTÃO" */}
        <text
          x="50%"
          y="202"
          textAnchor="middle"
          fill={subtextColor}
          fontSize="36"
          fontWeight="600"
          fontFamily="'Inter', 'Segoe UI', system-ui, sans-serif"
          letterSpacing="9"
          opacity="0.95"
        >
          SOLUÇÕES EM SISTEMAS DE EXAUSTÃO
        </text>
      </svg>
    </div>
  );
}
